import { useState } from "react"

export const useSessionStorage = (key, defaultValue) => {
    const [data, setData] = useState(() => {
        const storedData = sessionStorage.getItem(key);

        return storedData ? JSON.parse(storedData) : defaultValue
    });

    const setSessionStorage = (newData) => {
        sessionStorage.setItem(key, JSON.stringify(newData));
        setData(newData);
    }

    return [
        data,
        setSessionStorage
    ]
}